import FoodBanner from "../../assets/food-banner-our-story.png";
import RiceChicken from "../../assets/rice-chicken-aloco.jpg";
import { t } from "../../translations";

const OurStoryBanner = ({ lang }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        overflow: "auto",
        flexDirection: "column",
        marginBottom: "50px",
        paddingBottom: "50px"
      }}
    >
      <div className="FoodBannerStory">
        <div className="FoodBannerStoryImgContainer">
          <img className="FoodBannerStoryImg" src={FoodBanner} alt="" />
        </div>
        <div className="darkBgBannerFoodStory"></div>
        <p className="TextBannerStory">
          {t("our_story_banner.banner_text_part1", lang)}{" "}
          <u className="underlineYellow">
            {t("our_story_banner.banner_underline1", lang)}
          </u>{" "}
          {t("our_story_banner.banner_text_part2", lang)}{" "}
          <u className="underlineYellow">
            {t("our_story_banner.banner_underline2", lang)}
          </u>{" "}
          {t("our_story_banner.banner_text_part3", lang)}{" "}
          <u className="underlineYellow">
            {t("our_story_banner.banner_underline3", lang)}
          </u>{" "}
          {t("our_story_banner.banner_text_part4", lang)}
        </p>
      </div>

      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <div
          className="PowerHomeMadeMeal OurFonudingStory"
          style={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap"
          }}
        >
          <h1
            style={{
              textAlign: "center",
              marginBottom: "30px",
              width: "100%",
              fontSize: "2.5rem",
              fontWeight: "bold"
            }}
          >
            {t("our_story_banner.our_story_title", lang)}
          </h1>

          <div
            style={{ maxWidth: "800px", lineHeight: "1.8", fontSize: "16px" }}
          >
            <p className="pStory" style={{ marginBottom: "20px" }}>
              {t("our_story_banner.paragraph1", lang)}
            </p>

            <p className="pStory" style={{ marginBottom: "20px" }}>
              {t("our_story_banner.paragraph2", lang)}
            </p>

            <p className="pStory" style={{ marginBottom: "20px" }}>
              {t("our_story_banner.paragraph3", lang)}
            </p>

            <p className="pStory" style={{ marginBottom: "20px" }}>
              {t("our_story_banner.paragraph4", lang)}
            </p>

            <p
              className="pStory"
              style={{
                marginBottom: "30px",
                textAlign: "center",
                fontWeight: "600"
              }}
            >
              {t("our_story_banner.cta_part1", lang)}{" "}
              <a
                href="https://www.panichefs.com"
                style={{ color: "#FF114D", fontWeight: "600" }}
              >
                www.panichefs.com
              </a>{" "}
              {t("our_story_banner.cta_part2", lang)}
            </p>
          </div>
        </div>
      </div>

      <div className="OurStoryImgCentered">
        <img src={RiceChicken} alt="rice with grilled chicken and aloco" />
      </div>

      <a href="/" className="decouChef">
        {t("our_story_banner.discover_local_chefs", lang, false)}
      </a>
    </div>
  );
};

export default OurStoryBanner;
